import { render, staticRenderFns } from "./TwoButtonsModal.vue?vue&type=template&id=e91864a0&scoped=true&"
import script from "./TwoButtonsModal.vue?vue&type=script&lang=js&"
export * from "./TwoButtonsModal.vue?vue&type=script&lang=js&"
import style0 from "./TwoButtonsModal.vue?vue&type=style&index=0&id=e91864a0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e91864a0",
  null
  
)

export default component.exports